import React, { useContext } from "react";
import { Box } from "@mui/material";
import { UserContext } from "../../../context/UserContext";
import ProductVariants from "../../../product/component/ProductVariants";

export default function ItemVariantEntry(props) {
  const { productType, variant, fields } = props;
  const { user } = useContext(UserContext);

  return (
    <Box>
      <Box>
        <ProductVariants
          basePrice={props.basePrice}
          variant={variant}
          fields={fields}
          onChange={(o) => {
            props.onChange(o);
          }}
        />
      </Box>
    </Box>
  );
}
